import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => {
  return {
    root: {
      borderColor: '#A1AAE380',
      borderRadius: '10px',
      '& img': {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
      },
    },
    fileFormatCard: {
      width: '100%',
      height: 200,
      backgroundColor: '#f8f9fd',
      borderBottom: '1px solid #A1AAE380',
      '& div': {
        color: theme.palette.grey[600],
      },
    },
    content: {
      paddingBottom: `${theme.spacing(2)} !important`,
    },
    date: {
      paddingTop: theme.spacing(0.5),
      direction: 'rtl !important',
      textAlign: 'left',
      fontSize: 13,
    },
    buttonGroup: {
      marginBlockStart: theme.spacing(1),
      marginBottom: '-10px',
      justifyContent: 'flex-start',
      flexDirection: 'row-reverse',
    },
    deleteButton: {
      marginInlineStart: theme.spacing(1),
      fontSize: 12,
      height: 35,
      padding: 0,
    },
    viewButton: {
      marginInlineStart: 10,
      fontSize: 12,
      marginBottom: 10,
      height: 35,
      padding: 0,
    },
    fileName: {
      cursor: 'pointer',
    },
  };
});
